import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, getInlineLoader } from "../Helpers"
import ContentDetails from "../ones/ContentDetails"

export default function ViewVideo({ uuid }) {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [data, setData] = useState(null);

  async function init() {
    setReady(false);
    await callApi('get-video-data', { uuid }).then((response) => {
      if (response.status === 1) {
        setData(response.data);
      } else {
        setData(null);
        appContext.tellError(response.msg || 'Could not fetch video');
      }
    })
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [uuid])

  if (ready && data) {
    return <ContentDetails data={data} type="Video" />
  }

  if (ready) {
    return <div className="container marketplace-empty-state mt-5">Video was not found</div>
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
